import { gql } from "@apollo/client";

export const rankQuery = gql`
query MyQuery {
  aatmsv4_ranks(order_by: {rank: asc, clientname: asc}, where: {active: {_eq: true}}) {
    active
    clientname
    clientsid
    rank
    ranksid
  }
}`

export const Rank_Query = gql`
query MyQuery(
  $active: Boolean

) {
  aatmsv4_ranks(order_by: {rank: asc, clientname: asc}, where: {active: {_eq: $active}}) {
    active
    clientname
    clientsid
    rank
    ranksid
  }
}`

export const clients = gql`
query Da_Clients {
  aatmsv4_clients{
    clientsid
    clientname
  }
}
`

  
export const insertRank = gql`

mutation MyMutation(
  $rankName: String!
  $clientid: uuid!
  $clientname: String!
) {
  insert_aatmsv4_ranks(objects: {clientsid: $clientid, clientname: $clientname, active: true, _aircraft: true, _crew: true, _ground: true, _manager: true, _optmiser: true, _simulator: true, rank: $rankName}) {
    returning {
      clientname
      rank
      active
      clientsid
    }
  }
}
`;

  export const UpdateRank = gql`
  mutation MyMutation(
    $rank: String
    $clientid: uuid
    $id: uuid
    $clientname: String
    $active: Boolean
  ) {
    update_aatmsv4_ranks(where: {ranksid: {_eq: $id}}, _set: {active: $active, clientname: $clientname, clientsid: $clientid, rank: $rank}) {
      returning {
        clientname
        clientsid
        ranksid
        rank
        active
      }
    }
  }
  
`;
